module.exports = __webpack_public_path__ + "static/media/logo-orig2.d8cfc1d0.png";